import React, { createContext, Dispatch, ReactNode, SetStateAction, useContext } from 'react';
import { OrderItemPaymentOrRefundLog } from 'src/admin-entity/interface/order/order-item-payment-or-refund-log.interface';
import { OrderItemProductStatusLog } from 'src/admin-entity/interface/order/order-item-product-status-log.interface';

type ContextType = {
    isLogOpen: boolean;
    setIsLogOpen: Dispatch<SetStateAction<boolean>>;
    logs: OrderItemProductStatusLog[];
    setLogs: React.Dispatch<React.SetStateAction<OrderItemProductStatusLog[]>>;
    orderItemPaymentOrRefundLog: OrderItemPaymentOrRefundLog;
    setOrderItemPaymentOrRefundLog: React.Dispatch<React.SetStateAction<OrderItemPaymentOrRefundLog>>;
};

const OrderProductLogContext = createContext<ContextType>(undefined);

export function OrderProductLogContextProvider({ children }: { children: ReactNode }) {
    const [isLogOpen, setIsLogOpen] = React.useState(false);
    const [logs, setLogs] = React.useState<OrderItemProductStatusLog[]>([]);
    const [orderItemPaymentOrRefundLog, setOrderItemPaymentOrRefundLog] =
        React.useState<OrderItemPaymentOrRefundLog>(null);

    return (
        <OrderProductLogContext.Provider
            value={{
                isLogOpen,
                setIsLogOpen,
                logs,
                setLogs,
                orderItemPaymentOrRefundLog,
                setOrderItemPaymentOrRefundLog,
            }}
        >
            {children}
        </OrderProductLogContext.Provider>
    );
}

export function useOrderProductLogState(): ContextType {
    const state = useContext(OrderProductLogContext);
    if (!state) throw new Error('OrderProductLogContext Error');
    return state;
}
